import { AccessRequestForm } from '@/features/access-request/AccessRequestForm';
import './RequestAccess.css';

export function RequestAccess() {
  return (
    <section className="section section--dark" id="request-access">
      <div className="container ra__inner">
        <div className="ra__copy">
          <span className="overline">Request access</span>
          <h2>Start carrying less of it yourself</h2>
          <p>
            Tell us who you’re caring for and we’ll come back to you — normally within one business day
            — with your onboarding link and what to expect from the release you’re joining.
          </p>
          <ul className="ra__list">
            <li>One household subscription, not per person</li>
            <li>Medical Power of Attorney included</li>
            <li>Native iOS and Android</li>
            <li>A person replies, not an autoresponder</li>
          </ul>
          <p className="ra__b2b">
            Sizing this for a workforce or a ward instead?{' '}
            <a href="https://aximedic.com/contact.html">Talk to our team</a> — that’s a different
            conversation.
          </p>
        </div>

        <div className="ra__form">
          <AccessRequestForm />
        </div>
      </div>
    </section>
  );
}
